// Resolves once Inter is loaded, so overlays that open on first paint do not swap fonts.
// `document.fonts.ready` resolves early when nothing has requested Inter yet; `fonts.load`
// triggers the request and awaits it.

const INTER_WEIGHTS = ['300', '400', '500', '600', '700', '800'] as const

// Cap so a font-CDN outage cannot block the caller.
const FONT_READY_TIMEOUT_MS = 1500

export function waitForInterFontsReady(): Promise<void> {
  // `allSettled`: `fonts.load` rejects when a weight fails to fetch, and that must not block the caller.
  const fontsReady =
    typeof document !== 'undefined' && 'fonts' in document
      ? Promise.allSettled(INTER_WEIGHTS.map(weight => document.fonts.load(`${weight} 1em Inter`)))
      : Promise.resolve()

  return Promise.race([fontsReady, new Promise<void>(resolve => setTimeout(resolve, FONT_READY_TIMEOUT_MS))]).then(
    () => undefined,
  )
}
